var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles)},[_c('video',{attrs:{"src":_vm.propValue,"controls":"","loop":"","crossorigin":"Anonymous","poster":_vm.propValue + '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,ar_auto'}})])}
var staticRenderFns = []

export { render, staticRenderFns }